import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ComponentsService {

  constructor(private readonly http: HttpClient) {
  }

  findResources(idproyecto: number, idioma: string) {
    let params = new HttpParams();
    params = params.append('idproyecto', idproyecto);
    params = params.append('idioma', idioma);
    return this.http.get(`${environment.api_url_base_dataform_component}/findResources`, {params: params})
      .pipe(map(data => data));
  }

  actionInstanceComponent(componentIns: any, action: string) {

    let params = new HttpParams();
    params = params.append('action', action);
    return this.http.post(`${environment.api_url_base_dataform_component}/actionInstanceComponent`, componentIns, {params: params}).pipe(map(data => data));
  }

  displayOption(idProject: number, idTask: number, user: string) {
    let params = new HttpParams();
    params = params.append('idProject', idProject);
    params = params.append('idTask', idTask);
    params = params.append('user', user);
    return this.http.get(`${environment.api_url_base_dataform_component}/displayOption`, {params: params})
      .pipe(map(data => data));
  }

  getHistoric(idProject: number, idComponentDet: number) {
    let params = new HttpParams();
    params = params.append('idProject', idProject);
    params = params.append('idComponentDet', idComponentDet);
    return this.http.get(`${environment.api_url_base_dataform_component}/historic`, {params: params})
      .pipe(map(data => data));
  }
}
